import { ApplicationElement, html } from '@crossiety/lit-components';
import { ifDefined } from 'lit/directives/if-defined.js';

import '@crossiety/lit-components/components/icon/element.js';

import style from './style.lit.css';

/**
 * Label component with location information.
 *
 * @prop picture - Renders image instead of icon, optional
 * @prop icon - Rendered if picture is not present, has default icon, can be changed, optional.
 * @prop url - Wraps component in link tag, optional.
 * @prop border - Add border around component, optional.
 * @prop name - Internal => will be derived from the slot.
 *
 * @slot default - For label
 */

export default class Origin extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  static properties = {
    picture: { type: String },
    icon: { type: String },
    url: { type: String },
    border: { type: Boolean, reflect: true },
    name: { state: true },
  };

  constructor() {
    super();
    this.icon = 'vector-circle';
  }

  onSlotChange() {
    this.name = this.innerText;
  }

  renderPicture() {
    return html`<img src="${this.picture}" alt=${ifDefined(this.name)} />`;
  }

  renderIcon() {
    return html`<ef-icon name=${this.icon}></ef-icon>`;
  }

  renderContent() {
    return html`
      ${this.picture ? this.renderPicture() : this.renderIcon()}
      <slot @slotchange=${this.onSlotChange}></slot>
    `;
  }

  renderContentWithLink() {
    return html`<a href=${this.url}>${this.renderContent()}</a>`;
  }

  render() {
    return html`
      ${this.url ? this.renderContentWithLink() : this.renderContent()}
    `;
  }
}

customElements.get('xs-origin') || customElements.define('xs-origin', Origin);
